import * as Pwa from '@helpers/pwa';

export function init(): void {
    Pwa.registrarServiceWorker();

    const form  = document.querySelector<HTMLFormElement>('form');
    const botao = document.getElementById('btnEntrar') as HTMLButtonElement | null;
    if (!form || !botao) return;

    form.addEventListener('submit', () => {
        botao.disabled = true;
        botao.innerHTML = '<span class="spinner-border spinner-border-sm me-2"></span>Entrando...';
    });
}
